import type { TextResponse } from '@assessments/shared'

interface Props {
  value: TextResponse
  onChange: (response: TextResponse) => void
  labelledBy: string
  describedBy?: string
  disabled?: boolean
}

/**
 * Multi-line essay answer that ships as a plain multi-line field;
 */
export function EssayQuestion({ value, onChange, labelledBy, describedBy, disabled }: Props) {
  return (
    <textarea
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      rows={6}
      disabled={disabled}
      value={value.text}
      onChange={(e) => onChange({ kind: 'text', text: e.target.value })}
      className="mt-3 w-full rounded-button border border-input px-3 py-2 text-sm text-body focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus disabled:opacity-50"
    />
  )
}
